const caret = (theme, side) => ({
  content: '""',
  position: 'absolute',
  top: 0,
  bottom: 0,
  [side]: -(theme.spacing(0.5) + 1),
  width: 2,
  background: theme.palette.primary.main,
});

export default (theme) => ({
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  item: {
    position: 'relative',
  },
  caretBefore: {
    '&::before': caret(theme, 'left'),
  },
  caretAfter: {
    '&::after': caret(theme, 'right'),
  },
  dragging: {
    opacity: 0.6,
  },
  overlay: {
    cursor: 'grabbing',
    // Doubled class outranks a cursor the caller's rendered item sets on itself.
    '&& *': {
      cursor: 'grabbing',
    },
  },
});
